/** A trip field an update may change. Each value is the API's field-mask path and the name of the trip's broker. */
export var TripField;
(function (TripField) {
    TripField["TITLE"] = "title";
    TripField["ABOUT"] = "about";
    TripField["DATE_RANGE"] = "dateRange";
})(TripField || (TripField = {}));
//# sourceMappingURL=TripField.js.map